<template>
  <div class="text-end mb-3">
    <button
      class="btn btn-primary"
      title="Exportar para Excel"
      @click="exportToExcel"
    >
      Exportar para Excel
    </button>
  </div>
  <div class="card">
    <div class="table-responsive table-scrollable">
      <table class="table table-sm table-bordered" id="tableReport">
        <thead class="text-center">
          <tr>
            <th class="position-sticky start-0 top-0 bg-dark text-white fs-xs">
              Item de despesa <br />(Natureza Orçamentária)
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              <div>Janeiro</div>
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Fevereiro
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Março
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Abril
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Maio
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Junho
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Julho
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Agosto
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Setembro
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Outubro
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Novembro
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Dezembro
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="2"
            >
              Valor Total
              <div class="row">
                <span class="col-6">Proposto</span>
                <span class="col-6">Realizado</span>
              </div>
            </th>
            <th
              class="position-sticky top-0 bg-teal text-white fs-xs"
              colspan="1"
            >
              Valor Bloqueado
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="ccPai in reports.centrosCustos"
            :key="ccPai.codCCustoPai"
          >
            <tr>
              <td class="position-sticky start-0 fs-lg">
                <strong>
                  {{ ccPai.codCCustoPai }} - {{ ccPai.nomeCCustoPai }}
                </strong>
              </td>
              <td v-for="index in 27" :key="index" class="text-center">-</td>
            </tr>
            <template
              v-for="ccFilho in ccPai.ccFilhos"
              :key="ccFilho.codCCustoFilho"
            >
              <template v-if="ccFilho.naturezasOrcamentarias">
                <tr>
                  <td class="position-sticky start-0">
                    <strong>
                      {{ ccFilho.codCCustoFilho }} -
                      {{ ccFilho.nomeCCustoFilho }}
                    </strong>
                  </td>
                  <td v-for="index in 27" :key="index" class="text-center">
                    -
                  </td>
                </tr>
                <tr
                  v-for="naturezaOrcamentaria in ccFilho.naturezasOrcamentarias"
                  :key="naturezaOrcamentaria.codTBOrcamento"
                >
                  <td class="position-sticky start-0 fs-smxs">
                    {{ naturezaOrcamentaria.codTBOrcamento }} -
                    {{ naturezaOrcamentaria.nomeTBOrcamento }}
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.janeiroOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.janeiroOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.janeiroRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.janeiroRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.fevereiroOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.fevereiroOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.fevereiroRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.fevereiroRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.marcoOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.marcoOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.marcoRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.marcoRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.abrilOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.abrilOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.abrilRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.abrilRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.maioOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.maioOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.maioRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.maioRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.junhoOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.junhoOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.junhoRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.junhoRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.julhoOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.julhoOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.julhoRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.julhoRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.agostoOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.agostoOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.agostoRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.agostoRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.setembroOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.setembroOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.setembroRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.setembroRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.outubroOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.outubroOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.outubroRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.outubroRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.novembroOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.novembroOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.novembroRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.novembroRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.dezembroOrcado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.dezembroOrcado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.dezembroRealizado">
                      {{
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.dezembroRealizado,
                        )
                      }}
                    </span>
                    <span v-else>{{ moneyToCurrencyBrNoSymbol(0) }}</span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.totalAnoOrcado">
                      <strong>
                        {{
                          moneyToCurrencyBrNoSymbol(
                            naturezaOrcamentaria.totalAnoOrcado,
                          )
                        }}
                      </strong>
                    </span>
                    <span v-else>
                      <strong>{{ moneyToCurrencyBrNoSymbol(0) }}</strong>
                    </span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.totalAnoRealizado">
                      <strong>
                        {{
                          moneyToCurrencyBrNoSymbol(
                            naturezaOrcamentaria.totalAnoRealizado,
                          )
                        }}
                      </strong>
                    </span>
                    <span v-else>
                      <strong>{{ moneyToCurrencyBrNoSymbol(0) }}</strong>
                    </span>
                  </td>
                  <td class="fs-smxs text-center">
                    <span v-if="naturezaOrcamentaria.totalBloqueado">
                      <strong>
                        {{
                          moneyToCurrencyBrNoSymbol(
                            naturezaOrcamentaria.totalBloqueado,
                          )
                        }}
                      </strong>
                    </span>
                    <span v-else>
                      <strong>
                        {{ moneyToCurrencyBrNoSymbol(0) }}
                      </strong>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td class="position-sticky start-0">
                    <strong>Total</strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.janeiroOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.janeiroRealizado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.fevereiroOrcado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.fevereiroRealizado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.marcoOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.marcoRealizado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.abrilOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.abrilRealizado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{ moneyToCurrencyBrNoSymbol(ccFilho.totais.maioOrcado) }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.maioRealizado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.junhoOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.junhoRealizado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.julhoOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.julhoRealizado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.agostoOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.agostoRealizado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.setembroOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.setembroRealizado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.outubroOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.outubroRealizado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.novembroOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.novembroRealizado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.dezembroOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.dezembroRealizado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.totalAnoOrcado)
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(
                          ccFilho.totais.totalAnoRealizado,
                        )
                      }}
                    </strong>
                  </td>
                  <td class="fs-smxs text-center">
                    <strong>
                      {{
                        moneyToCurrencyBrNoSymbol(ccFilho.totais.totalBloqueado)
                      }}
                    </strong>
                  </td>
                </tr>
              </template>
            </template>
            <tr class="table-primary">
              <td class="position-sticky start-0">
                <strong>
                  Total do Centro de Custo ({{ ccPai.codCCustoPai }})
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.janeiroOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.janeiroRealizado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.fevereiroOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{
                    moneyToCurrencyBrNoSymbol(ccPai.totais.fevereiroRealizado)
                  }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.marcoOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.marcoRealizado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.abrilOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.abrilRealizado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.maioOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.maioRealizado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.junhoOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.junhoRealizado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.julhoOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.julhoRealizado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.agostoOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.agostoRealizado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.setembroOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{
                    moneyToCurrencyBrNoSymbol(ccPai.totais.setembroRealizado)
                  }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.outubroOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.outubroRealizado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.novembroOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{
                    moneyToCurrencyBrNoSymbol(ccPai.totais.novembroRealizado)
                  }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.dezembroOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{
                    moneyToCurrencyBrNoSymbol(ccPai.totais.dezembroRealizado)
                  }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.totalAnoOrcado) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{
                    moneyToCurrencyBrNoSymbol(ccPai.totais.totalAnoRealizado)
                  }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBrNoSymbol(ccPai.totais.totalBloqueado) }}
                </strong>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { moneyToCurrencyBrNoSymbol } from '@/utils/strings'
import '@/assets/js/jquery.table2excel'

export default {
  name: 'OrcamentoTempoRealResult',

  props: {
    reports: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moneyToCurrencyBrNoSymbol,
    }
  },

  methods: {
    exportToExcel() {
      window.$('#tableReport').table2excel({
        name: 'Orcamento em Tempo Real',
        filename: 'Relatorio_SGCC_Orcamento_Tempo_Real.xls',
      })
    },
  },
}
</script>

<style scoped>
th.position-sticky.start-0.top-0 {
  min-width: 20rem;
  z-index: 2;
}

th {
  min-width: 12rem;
}

td {
  min-width: 6rem;
}

td.position-sticky,
th.position-sticky {
  z-index: 1;
}

td.position-sticky {
  background-color: #f1f1f7;
}

td {
  background-color: #f6f6f6;
  padding: 0.5rem 0.3rem;
}
</style>
